import dayjs from 'dayjs';
import dayjsTh from 'dayjs/locale/th';
dayjs.locale(dayjsTh);
import { gsap } from 'gsap';
import { Flip } from 'gsap/all';
gsap.registerPlugin(Flip);
